module.exports = __webpack_public_path__ + "static/map-683f0626999e161e8ec91b816507bfc9.png";